<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      Controller
    </mat-panel-title>
    <mat-panel-description>
      {{ controllerName }}
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-form-field class="form-element" appearance="fill">
    <mat-label>Select controller</mat-label>
    <input type="text" placeholder="Search controller" matInput [formControl]="controllerControl"
      [matAutocomplete]="controllerAuto" (focus)="onControllerInputFocus()"
      (blur)="updateController($event.target.value)" (input)="controllerChanges.next($event.target.value)" />
    <mat-autocomplete #controllerAuto="matAutocomplete" (optionSelected)="setControllerChangeAction($event)">
      @for (option of controllerSuggestions | async; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (controllerControl.hasError('required')) {
      <mat-error>The field name is required</mat-error>
    }
    @if (controllerControl.hasError('noOption')) {
      <mat-error>Controller not Found</mat-error>
    }
  </mat-form-field>

  @if (showControllerForm) {
    <div class="container inner-item" novalidate>
      @if (controller | async) {
        <form [formGroup]="controllerForm">
          <details class="controller-attribute-section" open>
            <summary>General</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>Name [name]</mat-label>
                <input matInput placeholder="Name" formControlName="name">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Description [description]</mat-label>
                <input matInput placeholder="Description" formControlName="description">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>UUID [uuid]</mat-label>
                <input matInput placeholder="UUID" formControlName="uuid">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Item [item]</mat-label>
                <input matInput placeholder="Item" formControlName="item">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Net Weight [net_weight]</mat-label>
                <input matInput placeholder="Net Weight" formControlName="net_weight">
                <span matSuffix>kg</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Gross weight [gross_weight]</mat-label>
                <input matInput placeholder="Gross weight" formControlName="gross_weight">
                <span matSuffix>kg</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>packaging [packaging]</mat-label>
                <input matInput placeholder="packaging" [value]="controllerForm.get('packaging')?.value?.name || controllerForm.get('packaging')?.value?.uuid || controllerForm.get('packaging')?.value" disabled>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>min temp [min_temp]</mat-label>
                <input matInput placeholder="min temp" formControlName="min_temp">
                <span matSuffix>°C</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>max temp [max_temp]</mat-label>
                <input matInput placeholder="max temp" formControlName="max_temp">
                <span matSuffix>°C</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>enclosure class [ingress_protection_code]</mat-label>
                <input matInput placeholder="enclosure class" formControlName="ingress_protection_code">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>efficiency [efficiency]</mat-label>
                <input matInput placeholder="efficiency" formControlName="efficiency">
                <span matSuffix>%</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Min Cable Size [min_cable_size]</mat-label>
                <input matInput placeholder="Min Cable Size" formControlName="min_cable_size">
                <span matSuffix>m&#x33A1;</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>economical_value_for_sort_order [economical_value_for_sort_order]</mat-label>
                <input matInput placeholder="economical_value_for_sort_order" formControlName="economical_value_for_sort_order">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>U Factor [u_factor]</mat-label>
                <input matInput placeholder="U Factor" formControlName="u_factor">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>I Factor [i_factor]</mat-label>
                <input matInput placeholder="I Factor" formControlName="i_factor">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>I Offset [i_offset]</mat-label>
                <input matInput placeholder="I Offset" formControlName="i_offset">
              </mat-form-field>
              @for (field of additionalFields['general']; track field.name) {
                <mat-form-field class="form-element">
                  <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                  @if (field.type === 'number') {
                    <input matInput type="number" [formControlName]="field.name">
                  } @else {
                    <input matInput type="text" [formControlName]="field.name">
                  }
                  @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                </mat-form-field>
              }
            </div>
          </details>
          <details class="controller-attribute-section">
            <summary>Dimensions</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>h [h]</mat-label>
                <input matInput placeholder="h" formControlName="h">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>h1 [h1]</mat-label>
                <input matInput placeholder="h1" formControlName="h1">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>h2 [h2]</mat-label>
                <input matInput placeholder="h2" formControlName="h2">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>h3 [h3]</mat-label>
                <input matInput placeholder="h3" formControlName="h3">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>w [w]</mat-label>
                <input matInput placeholder="w" formControlName="w">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>w1 [w1]</mat-label>
                <input matInput placeholder="w1" formControlName="w1">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>w2 [w2]</mat-label>
                <input matInput placeholder="w2" formControlName="w2">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>w3 [w3]</mat-label>
                <input matInput placeholder="w3" formControlName="w3">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>d [d]</mat-label>
                <input matInput placeholder="d" formControlName="d">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>d1 [d1]</mat-label>
                <input matInput placeholder="d1" formControlName="d1">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>d2 [d2]</mat-label>
                <input matInput placeholder="d2" formControlName="d2">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>e [e]</mat-label>
                <input matInput placeholder="e" formControlName="e">
                <span matSuffix>mm</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>e1_dim [e1]</mat-label>
                <input matInput placeholder="e1_dim" formControlName="e1">
                <span matSuffix>mm</span>
              </mat-form-field>
            </div>
          </details>
          <details class="controller-attribute-section">
            <summary>Diagrams</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>drawing [drawing]</mat-label>
                <input matInput placeholder="drawing" formControlName="drawing">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>drawing url [drawing_url]</mat-label>
                <input matInput placeholder="drawing url" formControlName="drawing_url">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>picture [picture]</mat-label>
                <input matInput placeholder="picture" formControlName="picture">
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>picture url [picture_url]</mat-label>
                <input matInput placeholder="picture url" formControlName="picture_url">
              </mat-form-field>
            </div>
          </details>
          <details class="controller-attribute-section">
            <summary>Input AC</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>Operating voltage [op_voc]</mat-label>
                <input matInput type="text" placeholder="Operating voltage" formControlName="op_voc">
                <span matSuffix>V</span>
              </mat-form-field>
              @for (field of additionalFields['inputAc']; track field.name) {
                <mat-form-field class="form-element">
                  <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                  @if (field.type === 'number') {
                    <input matInput type="number" [formControlName]="field.name">
                  } @else {
                    <input matInput type="text" [formControlName]="field.name">
                  }
                  @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                </mat-form-field>
              }
            </div>
          </details>
          <details class="controller-attribute-section">
            <summary>Input DC</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>Max Voc [max_voc]</mat-label>
                <input matInput placeholder="Max Voc" formControlName="max_voc">
                <span matSuffix>V</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max I [max_i]</mat-label>
                <input matInput placeholder="Max I" formControlName="max_i">
                <span matSuffix>A</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max P [max_p]</mat-label>
                <input matInput placeholder="Max P" formControlName="max_p">
                <span matSuffix>W</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max PV short circuit current [max_isc]</mat-label>
                <input matInput placeholder="Max PV short circuit current" formControlName="max_isc">
                <span matSuffix>A</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Min recommended Vmp [min_vmp]</mat-label>
                <input matInput placeholder="Min recommended Vmp" formControlName="min_vmp">
                <span matSuffix>V</span>
              </mat-form-field>
              @for (field of additionalFields['inputDc']; track field.name) {
                <mat-form-field class="form-element">
                  <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                  @if (field.type === 'number') {
                    <input matInput type="number" [formControlName]="field.name">
                  } @else {
                    <input matInput type="text" [formControlName]="field.name">
                  }
                  @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                </mat-form-field>
              }
            </div>
          </details>
          <details class="controller-attribute-section">
            <summary>Output AC</summary>
            <div class="controller-attribute-group">
              <mat-form-field class="form-element">
                <mat-label>Rated voltage [output_rated_voc]</mat-label>
                <input matInput placeholder="Rated voltage" formControlName="output_rated_voc">
                <span matSuffix>V</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max. Output Voltage [max_output_voc]</mat-label>
                <input matInput type="text" placeholder="Max. Output Voltage" formControlName="max_output_voc">
                <span matSuffix>V</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max Output Current [max_output_i]</mat-label>
                <input matInput placeholder="Max Output Current" formControlName="max_output_i">
                <span matSuffix>A</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max continuous power [max_output_p]</mat-label>
                <input matInput placeholder="Max continuous power" formControlName="max_output_p">
                <span matSuffix>W</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Max frequency [max_freq]</mat-label>
                <input matInput placeholder="Max frequency" formControlName="max_freq">
                <span matSuffix>Hz</span>
              </mat-form-field>
              <mat-form-field class="form-element">
                <mat-label>Frequency range [freq_range]</mat-label>
                <input matInput placeholder="Frequency range" formControlName="freq_range">
              </mat-form-field>
              @for (field of additionalFields['outputAc']; track field.name) {
                <mat-form-field class="form-element">
                  <mat-label>{{ field.label }} [{{ field.name }}]</mat-label>
                  @if (field.type === 'number') {
                    <input matInput type="number" [formControlName]="field.name">
                  } @else {
                    <input matInput type="text" [formControlName]="field.name">
                  }
                  @if (field.unit) { <span matSuffix>{{ field.unit }}</span> }
                </mat-form-field>
              }
            </div>
          </details>
</form>
      } @else {
        <mat-progress-spinner mode="indeterminate" [diameter]=20></mat-progress-spinner>
      }
    </div>
  }
</mat-expansion-panel>